<div
  *ngIf="ready && !visibility.isHidden && anmResource"
  class="animation-container"
  [style.visibility]="visibility.isInvisible ? 'hidden' : 'visible'"
>
  <a
    *ngIf="animation.url; else animationTemplate"
    [href]="animation.url"
    target="_blank"
    rel="noopener noreferrer"
    (click)="onClick()"
  >
    <ng-lottie
      [options]="lottieOptions"
      (animationCreated)="onAnimationCreated($event)"
    ></ng-lottie>
  </a>
  <ng-template #animationTemplate>
    <ng-lottie
      (click)="onClick()"
      [options]="lottieOptions"
      (animationCreated)="onAnimationCreated($event)"
    ></ng-lottie>
  </ng-template>
</div>
